import { UserShortView } from "generated/CoreApi_v1";
import { TFunction } from "i18next";
import { useSession } from "providers/SessionProvider";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { AuthUser } from "services/authService";

////////////////////////////////////////////////////////////////////////////////

export function getFirstName(name: string) {
    if (name != null) {
        const arr = name.split(' ');
        if (arr.length > 0) return arr[0];
    }
    return name;
}

////////////////////////////////////////////////////////////////////////////////

export function userNameResolver(user: UserShortView, t: TFunction, authUser: AuthUser, firstNameOnly: boolean = false): string {

    if (user.userId == authUser.userId)
        return t("Literal.You", { ns: "shared" });

    let name = user.name;

    if (firstNameOnly && name != null) {
        name = getFirstName(name);
    }

    return name;
}


interface IProps {
    user: UserShortView;
    firstNameOnly?: boolean;
}

type Props = IProps;

const MprcUserNameView: React.FC<Props> = (props) => {

    const { user, firstNameOnly = false } = props;
    const session = useSession();
    const { t } = useTranslation();

    var name = userNameResolver(props.user, t, session.user, firstNameOnly);

    return (user.userId == session.user.userId)
        ? <b>{name}</b>
        : <span>{name}</span>;
};

export default MprcUserNameView;
